import Page from "containers/Page/Page";
import { Box, Typography } from "@mui/material";
interface SigilTablessPageProps {
  title: string;
  subtitle: string;
  Actions: React.ReactNode;
  actionOptions: unknown;
  children?: React.ReactNode;
}

const SigilTablessPage: React.FC<SigilTablessPageProps> = ({
  title,
  subtitle,
  children,
}) => {
  return (
    <Page title={title}>
      <Box sx={{ flexGrow: 1 }}>
        <Typography sx={{ mt: 1, mb: 1 }}>{subtitle}</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          height: `calc(100vh - 177px)`,
          mt: 2,
        }}
      >
        {children}
      </Box>
    </Page>
  );
};

export default SigilTablessPage;
